<div class="flex flex-column gap-2 w-full">
  @if (ctrlLabel()) {
    <label [for]="inputId()">{{ ctrlLabel() }}</label>
  }
  <p-datepicker
    [autofocus]="false"
    [showIcon]="true"
    appendTo="body"
    [formControl]="formCtrl()"
    [inputId]="inputId()"
    [placeholder]="ctrlPlaceholder()"
    [disabled]="isDisabled()"
    inputStyleClass="w-full"
    styleClass="w-full"
    [dateFormat]="dateFormat()"
    [minDate]="minDateCtrl()!"
    [maxDate]="maxDateCtrl()!"
    hourFormat="24"
    [showTime]="ctrlShowTime()"
    iconDisplay="input"
    [timeOnly]="timeOnly()"
    [inline]="inline()"
    [disabledDates]="unavailableDays()"
    [panelStyleClass]="panelStyleClass()"
    [selectionMode]="selectionMode()"
    [numberOfMonths]="numberOfMonths()"
    (onMonthChange)="handleMonthChanged($event)"
  >
    <ng-template #inputicon let-clickCallBack="clickCallBack">
      <i class="pi pi-chevron-down" (click)="clickCallBack($event)"></i>
    </ng-template>
  </p-datepicker>
  @if (!hideErrors()) {
    <app-error-required [formCtrl]="formCtrl()"></app-error-required>
  }
</div>
